var _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 12.5,
    fill: "#516C96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1082 16.2982C11.2462 16.3554 11.3053 16.508 11.2462 16.6414C11.0689 17.0801 10.99 17.5569 10.99 18.0337V19.9027H7.26566V18.6631C7.26566 17.9574 7.54153 17.3089 8.05381 16.8131C8.5661 16.3173 9.23622 16.0503 9.96525 16.0503C10.3593 16.0503 10.7535 16.1457 11.1082 16.2983L11.1082 16.2982Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4189 19.9219H11.5614V18.0529C11.5614 17.1755 11.9161 16.3365 12.5664 15.7071C13.2167 15.0777 14.0837 14.7344 14.9901 14.7344C15.8966 14.7344 16.7635 15.0777 17.4139 15.7071C18.0641 16.3364 18.4188 17.1756 18.4188 18.0529L18.4189 19.9219Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9904 18.0338C18.9904 17.557 18.9116 17.0992 18.7342 16.6416C18.6751 16.508 18.7342 16.3555 18.8722 16.2983C19.2268 16.1267 19.621 16.0504 20.0348 16.0504C20.7639 16.0504 21.434 16.3174 21.9462 16.8132C22.4585 17.309 22.7344 17.9575 22.7344 18.6631V19.9027H19.01V18.0337L18.9904 18.0338Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9902 13.9905C13.6699 13.9905 12.6058 12.9607 12.6058 11.6828C12.6058 10.4049 13.6698 9.375 14.9902 9.375C16.3105 9.375 17.3746 10.4048 17.3746 11.6828C17.3746 12.9607 16.3105 13.9905 14.9902 13.9905Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0151 15.6307C18.9707 15.6307 18.1036 14.8107 18.1036 13.7807C18.1036 12.7699 18.9509 11.9308 20.0151 11.9308C21.0595 11.9308 21.9265 12.7508 21.9265 13.7807C21.9265 14.7915 21.0791 15.6307 20.0151 15.6307Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96528 15.6307C8.92089 15.6307 8.05385 14.8107 8.05385 13.7807C8.05385 12.7699 8.90111 11.9308 9.96528 11.9308C11.0293 11.9308 11.8767 12.7508 11.8767 13.7807C11.8571 14.7915 11.0096 15.6307 9.96528 15.6307Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/groupIcon.1f454f8167924b433866921416e6fb36.svg";
export { ForwardRef as ReactComponent };